import { FC, lazy, ReactNode } from "react"

import { createRoot } from "react-dom/client"

import type { ConfirmDialogProps } from "@/components/ConfirmDialog"

const ConfirmDialog = lazy(() => import("@/components/ConfirmDialog"))

type ConfirmCustomProps = Omit<ConfirmDialogProps, "confirm" | "children"> & {
  custom: true
  message?: string | ReactNode
}
type ConfirmDefaultProps = Omit<ConfirmDialogProps, "confirm" | "children"> & {
  custom?: false
  message?: string | ReactNode
}

// Overloads
export default async function confirm(
  title: FC<{ confirm: (response: boolean) => void }>,
  props: ConfirmCustomProps
): Promise<boolean>
export default async function confirm(title: string | ReactNode, props?: ConfirmDefaultProps): Promise<boolean>

// Implementation
export default async function confirm(title: any, props?: any): Promise<boolean> {
  const el = document.createElement("div")
  document.body.appendChild(el)
  const root = createRoot(el)
  const response = new Promise<boolean>((resolve, reject) => {
    try {
      root.render(
        <ConfirmDialog confirm={resolve} title={title} {...props}>
          {props?.message}
        </ConfirmDialog>
      )
    } catch (e) {
      reject(e)
    }
  }).then((r) => {
    root.unmount()
    el.remove()
    return r
  })
  return response
}
